var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6873 9.74467L13.5427 12.5993L12.5993 13.5427L9.74467 10.6873C8.68249 11.5388 7.36133 12.0019 6 12C2.688 12 0 9.312 0 6C0 2.688 2.688 0 6 0C9.312 0 12 2.688 12 6C12.0019 7.36133 11.5388 8.68249 10.6873 9.74467ZM9.35 9.25C10.1961 8.37992 10.6686 7.21362 10.6667 6C10.6667 3.42133 8.578 1.33333 6 1.33333C3.42133 1.33333 1.33333 3.42133 1.33333 6C1.33333 8.578 3.42133 10.6667 6 10.6667C7.21362 10.6686 8.37992 10.1961 9.25 9.35L9.35 9.25Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 1.33333 1.33333)",
    fill: "currentColor"
  })));
};
export default SvgSearch;